import React from 'react';

import style from './products.module.scss';

import { Banner } from './banner';
import { Intro } from './intro';
import { Articles } from './articles';

export const Products = () => {
    return (
        <div className={style.products}>
            <Banner></Banner>
            <Intro></Intro>
            <Articles></Articles>
        </div>
    );
};
